import { useCookieConsentStore } from '@supsupclub/ui-components';
import { useEffect } from 'react';

const GA_MEASUREMENT_ID = 'G-9TBC4XY59M';

declare global {
  type GtagFunction = (...args: unknown[]) => void;

  type WindowWithGtag = Window &
    typeof globalThis & {
      dataLayer?: unknown[];
      gtag?: GtagFunction;
    };
}

const loadGoogleAnalytics = () => {
  const w = window as WindowWithGtag;
  if (w.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  w.dataLayer = w.dataLayer || [];
  const gtag: GtagFunction = (...args: unknown[]) => {
    w.dataLayer?.push(args);
  };
  w.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
};

const disableGoogleAnalytics = () => {
  const w = window as WindowWithGtag;
  (w as unknown as Record<string, unknown>)[`ga-disable-${GA_MEASUREMENT_ID}`] =
    true;

  document
    .querySelectorAll(`script[src*="googletagmanager.com/gtag/js"]`)
    .forEach((el) => el.remove());

  w.gtag = undefined;
  w.dataLayer = undefined;
};

export const useAnalyticsConsent = () => {
  const consent = useCookieConsentStore((s) => s.consent);

  useEffect(() => {
    if (!consent) return;

    if (consent.analytics) {
      loadGoogleAnalytics();
    } else {
      disableGoogleAnalytics();
    }
  }, [consent]);
};
